import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  FiUser, FiMail, FiLock, FiEye, FiEyeOff, FiCheck, FiArrowLeft,
  FiCode
} from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';

import Image from "../../../assets/logo.png";
import { Link, useNavigate } from 'react-router-dom';
import usePost from '../../../hooks/api/usePost';
import apiRequest from '../../../utils/apiRequest';
import toast from 'react-hot-toast';
import axios from 'axios';
import { setUserProfile } from '../../../store/slice/globalStore';
import authManager from '../../../utils/authManager';
import { formatValidationError, getFileUrl } from '../../../utils/helper';
import { DASHBOARD_ROUTE, FORGOT_PASSWORD_ROUTE, HOME_ROUTE, MEMBER_DASHBOARD_ROUTE } from '../../../routes/web/rootRoutes';
import { FORM_ROUTE } from '../../../routes/web/rootRoutes';


const LoginSignup = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isUnionMember, setIsUnionMember] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out-quad'
    });
  }, []);
  const setting = useSelector(
    (state) => state.globalState.siteSetting?.site_settings
  );

  // const forms = useSelector((state) => state.globalState?.siteSetting?.formData);
  // console.log(forms)

  const forms = useSelector((state) => state.globalState?.siteSetting?.formData);


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const membershipForm = useFormik({
    initialValues: {
      isMember: "yes"
    },
    validationSchema: Yup.object({
      isMember: Yup.string()
        .required('Please select an option')
        .oneOf(['yes', 'no'], 'Invalid selection')
    }),
    onSubmit: values => {
      setIsUnionMember(values.isMember === 'yes');
    }
  });



  const handleApply = (formType) => {
    // console.log(formType)
    navigate(FORM_ROUTE(formType));
  };
  const stripHtml = (html) => {
    if (typeof window === 'undefined') return html || "";
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const getFormColor = (type) => {
    const colorMap = {
      'MEDICAL': 'bg-blue-100 text-blue-800 border-blue-200',
      'REGISTRATION': 'bg-purple-500 text-purple-800 border-purple-200',
      'NOMINATION': 'bg-green-100 text-green-800 border-green-200',
      'Membership': 'bg-amber-100 text-amber-800 border-amber-200',
      'COMPLAINT': 'bg-red-100 text-red-800 border-red-200'
    };

    for (const [key, value] of Object.entries(colorMap)) {
      if (type.includes(key)) return value;
    }

    return 'bg-gray-100 text-gray-800 border-gray-200';
  };

  const getFormIcon = (type) => {
    const iconMap = {
      'Membership': '👥',
    };

    for (const [key, value] of Object.entries(iconMap)) {
      if (type.includes(key)) return value;
    }

    return '📄';
  };


  return (
    <div className="h-[100vh] flex items-center justify-center bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 ">
      <div className="w-full h-[100vh] grid grid-cols-1 lg:grid-cols-2 bg-white shadow-2xl overflow-hidden ">
        <div className="hidden border-r-2 lg:block relative" data-aos="fade-right">
          <div className="h-full w-full bg-gray-200 border-0" style={{
            backgroundImage: `url(${Image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}></div>
        </div>

        <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-start overflow-y-auto h-[100vh]" data-aos="fade-left">
          <div className="flex justify-center mb-6">
            <Link to={'/'}>
              <img
                src={getFileUrl(setting?.site_logo, 'setting')}
                alt="logo"
                loading="lazy"
                className="w-20 sm:w-28"
              />
            </Link>
          </div>

          {isUnionMember !== null && (
            <button
              onClick={() => setIsUnionMember(null)}
              className="flex items-center cursor-pointer font-semibold text-purple-600 mb-4 hover:text-purple-800 transition-colors"
            >
              <FiArrowLeft className="mr-2" /> Back
            </button>
          )}

          <div className="text-center mb-10">
            {isUnionMember === null ? (
              <form onSubmit={membershipForm.handleSubmit} className="space-y-6">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  Are you a dhadakkamgarfilmunion member?
                </h2>
                <p className="text-gray-600 mb-6">
                  Please confirm your membership status to continue
                </p>

                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-6">
                    <div className="flex items-center justify-center">
                      <div className="flex items-center mr-1">
                        <input
  id="yes"
  name="isMember"
  type="radio"
  value="yes"
  checked={membershipForm.values.isMember === 'yes'}
  onChange={membershipForm.handleChange}
  onBlur={membershipForm.handleBlur}
  className="h-5 w-5 text-purple-600"
/>


                       
                        <label htmlFor="yes" className="ml-2 block text-lg text-gray-700">
                          Yes, I'm a member
                        </label>
                      </div>

                      <div className="flex items-center">
                       
<input
  id="no"
  name="isMember"
  type="radio"
  value="no"
  checked={membershipForm.values.isMember === 'no'}
  onChange={membershipForm.handleChange}
  onBlur={membershipForm.handleBlur}
  className="h-5 w-5 text-purple-600"
/>
                        <label htmlFor="no" className="ml-2 block text-lg text-gray-700">
                          No, I'm not
                        </label>
                      </div>
                    </div>

                    {membershipForm.touched.isMember && membershipForm.errors.isMember && (
                      <p className="mt-1 text-red-500 text-sm">
                        {membershipForm.errors.isMember}
                      </p>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="mt-4 cursor-pointer w-full bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-3 rounded-xl font-semibold shadow-lg hover:from-purple-700 hover:to-indigo-800 transition-all transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
                  >
                    Continue
                  </button>
                </div>
              </form>
            ) : isUnionMember ? (
              <LoginForm
                showPassword={showPassword}
                togglePasswordVisibility={togglePasswordVisibility}
              />
            ) : (
              <>
              <div className="text-center py-8">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">Union Membership Required</h3>
                <p className="text-gray-600 mb-6 max-w-md mx-auto">
                  Only union members can access this system. If you believe this is an error,
                  please contact your union representative for assistance.
                </p>
                <button
                  onClick={() => setIsUnionMember(null)}
                  className="px-6 py-3 bg-gray-100 text-gray-800 rounded-lg font-medium hover:bg-gray-200 transition-colors"
                >
                  Back to Membership Check
                </button>


              </div>
                <div className="grid grid-cols-1  gap-4">
              {forms?.map((form) => {
                const formColor = getFormColor(form.type);
                const formIcon = getFormIcon(form.type);

                return (
                  <div
                    key={form.id}
                    className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex flex-col"
                  >
                    <div className={`p-5 border-b ${formColor} flex items-center justify-between`}>
                      <div className="flex items-center">
                        <span className="text-2xl mr-3">{formIcon}</span>
                        <span className="text-sm font-semibold">{form.type.split(' ')[0]}</span>
                      </div>
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-white bg-opacity-80">
                        {form.status}
                      </span>
                    </div>

                    <div className="p-6 flex-grow">
                      <div className="flex justify-between items-start mb-4">
                        <h2 className="text-lg font-bold text-gray-900 leading-tight">{form.title}</h2>
                        <span className="text-xs text-gray-500 whitespace-nowrap ml-2">
                          {new Date(form.created_at).toLocaleDateString()}
                        </span>
                      </div>

                      {form.sub_heading && form.sub_heading !== form.title && (
                        <p className="text-sm text-gray-600 mb-4">{form.sub_heading}</p>
                      )}

                      <div className="text-sm text-gray-700 mb-6 bg-gray-50 p-4 rounded-lg">
                        {stripHtml(form.description).length > 120
                          ? `${stripHtml(form.description).substring(0, 120)}...`
                          : stripHtml(form.description)
                        }
                      </div>
                    </div>

                    <div className="p-5 bg-gray-50 border-t border-gray-100">
                      <div className="flex flex-col sm:flex-row gap-3">
                        <button
                          onClick={() => handleApply(form.type)}
                          className="flex-1 flex items-center justify-center cursor-pointer bg-violet-600 font-semibold hover:bg-violet-800 text-white text-sm  py-3 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
                        >
                          <span className="mr-2">📋</span>
                          Apply Now {form.type}
                        </button>
                        <a
                          href={getFileUrl(form?.form, 'form')}
                          target='_blank'
                          className="flex-1 flex items-center justify-center cursor-pointer border border-gray-300 hover:bg-zinc-400 hover:text-white text-gray-700 text-sm font-medium py-3 px-4 rounded-lg transition-all duration-300"
                        >
                          <span className="mr-2">⬇️</span>
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
              </>
            )}
             
          </div>
        </div>
      </div>
    </div>
  );
};

const LoginForm = ({ showPassword, togglePasswordVisibility }) => {
  const { isLoading, post } = usePost(apiRequest.login);
  const [serverErrors, setServerErrors] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const formik = useFormik({
    initialValues: {
      union_code: '',
      password: '',
    },
    validationSchema: Yup.object({
      union_code: Yup.string()
        .required('Union code is required'),
      password: Yup.string()
        .min(5, 'Password must be at least 8 characters')
        .required('Password is required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      console.log(values);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}login`,
          values,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.status === 200 && response.data?.access_token) {

          const userData = {
            ...response.data.data,
            access_token: response.data.access_token,
            token_type: response.data.token_type,
            expires_in: response.data.expires_in,
          };

          authManager.setAccessToken(response.data.access_token);
          authManager.setUserProfile(response.data.data);

          dispatch(setUserProfile(userData));

          toast.success(`Hi ${response.data?.data?.name}, ${response.data?.msg || 'Login successful'}`);

          setTimeout(() => {
            navigate(DASHBOARD_ROUTE);
          }, 1000);
        } else {
          toast.error(response.data?.msg || 'Login failed');
        }


      } catch (error) {
        if (error.response?.status === 403) {
          return;
        } else if (error.response?.status === 422) {
          const formattedErrors = formatValidationError(error.response.data);
          setServerErrors(formattedErrors?.errors);
          setError(String(formattedErrors?.msg));
          toast.error(String(formattedErrors?.msg));
        } else {
          setServerErrors(null);
          setError(String(error?.response?.data?.message || error));
          toast.error(
            String(error?.response?.data?.message || error.response?.statusText)
          );
        }
      } finally {
        setSubmitting(false);
      }
    },

  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-6">
      <div className="text-center mb-6">
        <h2 className="text-3xl font-bold text-gray-800 mb-2">
          Union Member Login
        </h2>
        <p className="text-gray-600">
          Enter your union credentials to continue
        </p>
      </div>

      <div data-aos="fade-up" data-aos-delay="100">
        <label htmlFor="union_code" className="block text-left text-gray-700 font-medium mb-2">
          Union Code
        </label>
        <div className="relative text-left">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FiCode className="text-gray-400" />
          </div>
          <input
            id="union_code"
            name="union_code"
            placeholder="Enter your union code"
            className={`w-full pl-10 pr-4 py-3 rounded-xl  border ${formik.touched.union_code && formik.errors.union_code
              ? 'border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:ring-indigo-500'
              } focus:outline-none focus:ring-2 transition-colors text-left`}
            {...formik.getFieldProps('union_code')}
          />
        </div>
        {formik.touched.union_code && formik.errors.union_code && (
          <p className="mt-1 text-red-500 text-left text-sm">{formik.errors.union_code}</p>
        )}
      </div>

      <div data-aos="fade-up" data-aos-delay="150">
        <div className="flex justify-between items-center mb-2">
          <label htmlFor="password" className="block text-gray-700 font-medium">
            Password
          </label>
          <Link to={FORGOT_PASSWORD_ROUTE}  className="text-sm text-purple-600 hover:text-purple-800 transition-colors">
            Forgot Password?
          </Link>
        </div>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FiLock className="text-gray-400" />
          </div>
          <input
            id="password"
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="••••••••"
            className={`w-full pl-10 pr-10 py-3 rounded-xl border ${formik.touched.password && formik.errors.password
              ? 'border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:ring-indigo-500'
              } focus:outline-none focus:ring-2 transition-colors`}
            {...formik.getFieldProps('password')}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <FiEyeOff className="text-gray-400" /> : <FiEye className="text-gray-400" />}
          </button>
        </div>
        {formik.touched.password && formik.errors.password && (
          <p className="mt-1 text-red-500 text-sm text-left">{formik.errors.password}</p>
        )}
      </div>

      <div className="flex items-center" data-aos="fade-up" data-aos-delay="200">
        <input
          id="remember-me"
          name="remember-me"
          type="checkbox"
          className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
        />
        <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
          Remember me
        </label>
      </div>

      <button
        type="submit"
        className="w-full cursor-pointer bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-4 rounded-xl font-semibold shadow-lg hover:from-purple-700 hover:to-indigo-800 transition-all transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 group"
      >
        <div className="flex items-center cursor-pointer justify-center">
          <span>Sign In</span>
          <div className="ml-2 cursor-pointer transform group-hover:translate-x-1 transition-transform">
            <FiCheck />
          </div>
        </div>
      </button>
    </form>
  );
};

export default LoginSignup;